import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CurrencyData } from '../_models/currency';
import { ApiService } from '../_services/api.service';
import { ChecksService } from '../_services/checks.service';

@Component({
  selector: 'app-cross-exchange-rate',
  templateUrl: './cross-exchange-rate.component.html',
  styleUrl: './cross-exchange-rate.component.css'
})
export class CrossExchangeRateComponent implements OnInit {
  currencies: CurrencyData[] = [];
  loading = true;

  calculatorForm = this.fb.group({
    currencyA: ['', Validators.required],
    currencyB: ['', Validators.required],
    commonCurrency: ['', Validators.required],
    rateAC: [null as number | null, [Validators.required, Validators.min(0.00000001)]],
    rateBC: [null as number | null, [Validators.required, Validators.min(0.00000001)]],
  });

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    public checkService: ChecksService,
  ) {
    this.checkService.checkSession();
  }

  ngOnInit(): void {
    this.apiService.getActiveCurrencies().subscribe(data => {
      this.checkService.checkLoggedin(data);
      this.loading = false;
      if (data.success === true) {
        this.currencies = (data.data || []).filter((currency, index, list) =>
          currency?.code && list.findIndex(item => item.code === currency.code) === index
        );
      }
    });
  }

  get rateAC(): number { return Number(this.calculatorForm.value.rateAC) || 0; }
  get rateBC(): number { return Number(this.calculatorForm.value.rateBC) || 0; }
  get crossAB(): number { return this.rateAC > 0 && this.rateBC > 0 ? this.rateAC / this.rateBC : 0; }
  get crossBA(): number { return this.crossAB > 0 ? 1 / this.crossAB : 0; }
  get inverseAC(): number { return this.rateAC > 0 ? 1 / this.rateAC : 0; }
  get inverseBC(): number { return this.rateBC > 0 ? 1 / this.rateBC : 0; }
  get duplicateCurrencies(): boolean {
    const values = [this.calculatorForm.value.currencyA, this.calculatorForm.value.currencyB, this.calculatorForm.value.commonCurrency].filter(Boolean);
    return new Set(values).size !== values.length;
  }

  reset(): void {
    this.calculatorForm.reset({ currencyA: '', currencyB: '', commonCurrency: '', rateAC: null, rateBC: null });
  }
}
